import type {
  CalcOptions,
  NumberMatrix,
  TechnologyDatum,
} from "../algorithm.types";

type CalculateCurtailmentParams = {
  calcOptions: Pick<
    CalcOptions,
    "noOfStorTypes" | "noOfTechs" | "noOfTimeSlots"
  >;
  technologyData: ReadonlyArray<Pick<TechnologyDatum, "zeroCarbon">>;
  availData: NumberMatrix;
  genData: NumberMatrix;
};

export default function calculateCurtailment({
  calcOptions,
  technologyData,
  availData,
  genData,
}: CalculateCurtailmentParams): Array<number> {
  const { noOfStorTypes, noOfTechs, noOfTimeSlots } = calcOptions;

  const zeroCarbonAvail = Array(noOfTimeSlots).fill(0);
  const zeroCarbonGen = Array(noOfTimeSlots).fill(0);
  const curtailment: Array<number> = [];

  for (let j = 0; j < noOfTimeSlots; j++) {
    for (let i = 0; i < noOfTechs - noOfStorTypes; i++) {
      zeroCarbonAvail[j] += availData[i][j] * technologyData[i].zeroCarbon;
      zeroCarbonGen[j] += genData[i][j] * technologyData[i].zeroCarbon;
    }
  }

  for (let j = 0; j < noOfTimeSlots; j++) {
    curtailment.push(zeroCarbonAvail[j] - zeroCarbonGen[j]);
  }

  return curtailment;
}
